export default __webpack_public_path__ + "static/media/nav-arrow-right.51b22f90.svg";